export const TW_USER_ID = 'tw-user-id'
export const TW_USER_NAME = 'tw-user-name'
export const TW_AUTH_TOKEN = 'tw-auth-token'
export const TW_CLASS_ID = 'tw-class-id'
export const TW_CLASS_NAME = 'tw-class-name'

//http://localhost:4000/graphql
//export const ENDPOINT = 'http://la.tutorworks.net:8000'     //'http://viaje.local:8000'
export const ENDPOINT = 'https://laapi.tutorworks.net'
